<div class="a-example-full-width-alterno-content-column" *ngIf="!esVisualizar">
  <div class=".a-example-full-width-alterno-content">
    <div fxLayout="column" fxLayoutAlign="space-between stretch" style="height: 100%;">

      <p-button mat-icon-button mat-icon-button class="boton_arriba" (click)="guardarCotizacion()"
        [disabled]="!modovisualizar">
        <!-- <i class="pi pi-save" style="margin-right: 8px;"></i> Guardar</p-button> -->
        <i class="pi pi-save"></i>
      </p-button>
      <p-button type="button" class="boton_abajo" (click)="Salir('')">
        <!-- <i class="pi pi-sign-out" style="margin-right: 8px;"></i> Salir -->
        <i class="pi pi-sign-out"></i>
      </p-button>
    </div>
  </div>
</div>
<div style="margin-top: 1%;"></div>
<div class="a-example-full-width-alterno-content-column">

  <div class="a-example-full-width-alterno-content-row">
    <p-tabView class="a-example-full-width-alterno-content" [(activeIndex)]="activeIndex">

      <p-tabPanel header="Cotización">
        <form [formGroup]="group_tabcotizacion">
          <div style="margin-top: 1%;"></div>
          <div class="a-example-full-width-alterno-content-column-2">
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <input inputId="on_label" [ngClass]="{ readonly: readOnlyNumeroDGDG }" pInputText
                      formControlName="numeroCotizacion" appendTo="body" class="w-full md:w-56" />
                    <label for="on_label">Número</label>
                  </p-floatlabel>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <input inputId="on_label" [ngClass]="{ readonly: readOnlyVersionCotizacionDG }" pInputText
                      formControlName="version" appendTo="body" class="w-full md:w-56" />
                    <label for="on_label">Versión</label>
                  </p-floatlabel>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select inputId="on_label"
                      [ngClass]="{ 'ng-invalid ng-dirty': this.group_tabcotizacion.get('estado')?.invalid && (this.group_tabcotizacion.get('estado')?.touched), readonly: readOnlyEstadoDG }"
                      [options]="ListaTodosEstado" placeholder="‎ " optionLabel="nombre" formControlName="estado"
                      optionValue="codigo" appendTo="body" styleClass="w-full md:w-56">
                    </p-select>
                    <label for="on_label">Estado</label>
                  </p-floatlabel>
                  <small
                    *ngIf="this.group_tabcotizacion.get('estado')?.invalid && (this.group_tabcotizacion.get('estado')?.touched)"
                    class="text-red-500">
                    Este campo es obligatorio
                  </small>
                </div>
              </div>
              <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                <div class="card a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <input inputId="on_label" [ngClass]="{ readonly: readOnlyNoCRMDG }" pInputText
                      formControlName="numerocrm" appendTo="body" class="w-full md:w-56" />
                    <label for="on_label">No. CRM</label>
                  </p-floatlabel>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <input inputId="on_label" [ngClass]="{ readonly: readonlyOrdenCompraDG }" pInputText
                      formControlName="ordencompra" appendTo="body" class="w-full md:w-56" />
                    <label for="on_label">Orden Compra</label>
                  </p-floatlabel>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select inputId="on_label" #dropdownRegimen
                      [ngClass]="{ 'ng-invalid ng-dirty': this.group_tabcotizacion.get('regimen')?.invalid && (this.group_tabcotizacion.get('regimen')?.touched), readonly: readOnlyVisualizar }"
                      [options]="ListaTodosRegimen" placeholder="‎ " optionLabel="nombre" formControlName="regimen"
                      optionValue="codigo" (onChange)="onRegimenChange($event)" appendTo="body"
                      styleClass="w-full md:w-56">
                    </p-select>
                    <label for="on_label">Regimen</label>
                  </p-floatlabel>
                  <small
                    *ngIf="this.group_tabcotizacion.get('regimen')?.invalid && (this.group_tabcotizacion.get('regimen')?.touched)"
                    class="text-red-500">
                    Este campo es obligatorio
                  </small>
                </div>
              </div>
            </div>
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select inputId="on_label" [options]="ListaTodosVia"
                      [ngClass]="{ 'ng-invalid ng-dirty': this.group_tabcotizacion.get('via')?.invalid && (this.group_tabcotizacion.get('via')?.touched), readonly: readOnlyVisualizar }"
                      placeholder="‎ " optionLabel="nombre" formControlName="via" optionValue="codigo"
                      (onChange)="onViaChange($event)" appendTo="body" styleClass="w-full md:w-56">
                    </p-select>
                    <label for="on_label">Via</label>
                  </p-floatlabel>
                  <small
                    *ngIf="this.group_tabcotizacion.get('via')?.invalid && (this.group_tabcotizacion.get('via')?.touched)"
                    class="text-red-500">
                    Este campo es obligatorio
                  </small>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select inputId="on_label"
                      [ngClass]="{'ng-invalid ng-dirty': this.group_tabcotizacion.get('lineanegocio')?.invalid && (this.group_tabcotizacion.get('lineanegocio')?.touched), readonly: readOnlyVisualizar }"
                      [options]="ListaTodosLineaNegocio" placeholder="‎ " optionLabel="nombre"
                      formControlName="lineanegocio" (onChange)="onLineaNegocioChange($event)" optionValue="codigo"
                      appendTo="body" styleClass="w-full md:w-56">
                    </p-select>
                    <label for="on_label">Linea negocio</label>
                  </p-floatlabel>
                  <small
                    *ngIf="this.group_tabcotizacion.get('lineanegocio')?.invalid && (this.group_tabcotizacion.get('lineanegocio')?.touched)"
                    class="text-red-500">
                    Este campo es obligatorio
                  </small>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select inputId="on_label"
                      [ngClass]="{ 'ng-invalid ng-dirty': this.group_tabcotizacion.get('incoterm')?.invalid && (this.group_tabcotizacion.get('incoterm')?.touched), readonly: readOnlyVisualizar }"
                      [options]="ListaTodosIncoterm" placeholder="‎ " optionLabel="nombre" formControlName="incoterm"
                      optionValue="codigo" appendTo="body" styleClass="w-full md:w-56">
                    </p-select>
                    <label for="on_label">Incoterm</label>
                  </p-floatlabel>
                  <small
                    *ngIf="this.group_tabcotizacion.get('incoterm')?.invalid && (this.group_tabcotizacion.get('incoterm')?.touched)"
                    class="text-red-500">
                    Este campo es obligatorio
                  </small>
                </div>
              </div>
              <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-datepicker inputId="on_label" [ngClass]="{ readonly: true }" formControlName="fechaemision"
                      appendTo="body" [showIcon]="false" [showWeek]="false" styleClass="w-full md:w-56"
                      dateFormat="dd/mm/yy" (onSelect)="onFechaEmiChange($event)" [showOnFocus]="false"
                      [readonlyInput]="false" (onInput)="formatDateInput($event)">
                    </p-datepicker>
                    <label for="on_label">F. Emision</label>
                  </p-floatlabel>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-datepicker inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                      formControlName="fechavencimiento" appendTo="body" [showIcon]="true" [showWeek]="false"
                      styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [showOnFocus]="false" [readonlyInput]="false"
                      (onInput)="formatDateInput($event)">
                    </p-datepicker>
                    <label for="on_label">F. Vencimiento</label>
                  </p-floatlabel>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                  <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-datepicker inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                      formControlName="fechaaprobacion" appendTo="body" [showIcon]="true" [showWeek]="false"
                      dateFormat="dd/mm/yy" styleClass="w-full md:w-56" [showOnFocus]="false" [readonlyInput]="false"
                      (onInput)="formatDateInput($event)">
                    </p-datepicker>
                    <label for="on_label">F. Aprobacion</label>
                  </p-floatlabel>
                </div>
              </div>
            </div>
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" #dropdownRazonSocial
                    [ngClass]="{'ng-invalid ng-dirty': this.group_tabcotizacion.get('razonSocial')?.invalid && (this.group_tabcotizacion.get('razonSocial')?.touched), readonly: readOnlyVisualizar }"
                    [options]="ListaTodosRazonSocial" formControlName="razonSocial" optionLabel="nombre"
                    optionValue="nombre" appendTo="body" [filter]="true" [showClear]="true" styleClass="w-full md:w-56"
                    (onClear)="onClienteClear()" [virtualScroll]="true" [itemSize]="5"
                    (onChange)="onClienteChange($event)" (onHide)="onDropdownHide()">
                  </p-select>
                  <label for="on_label">Razón Social</label>
                </p-floatlabel>
                <small
                  *ngIf="this.group_tabcotizacion.get('razonSocial')?.invalid && (this.group_tabcotizacion.get('razonSocial')?.touched)"
                  class="text-red-500">
                  Este campo es obligatorio
                </small>
              </div>

              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full p-input-icon-right md:w-56" variant="on">
                  <p-iconfield>
                    <p-inputicon class="pi pi-search" (click)="cargaSunat()" />
                    <input inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" pInputText
                      formControlName="ruc" class="w-full md:w-56" (keydown.enter)="cargaSunat()" />
                  </p-iconfield>
                  <label for="on_label">RUC</label>
                </p-floatlabel>
              </div>

            </div>
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" [options]="listContacto"
                    placeholder="‎ " optionLabel="nombre" formControlName="contacto" optionValue="nombre"
                    appendTo="body" [filter]="true" [showClear]="true" styleClass="w-full md:w-56" dataKey="nombre">
                  </p-select>
                  <label for="on_label">Contacto</label>
                </p-floatlabel>
              </div>
              <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                <div class="card a-example-full-width-alterno-content-4" style="align-items: center;">
                  <p-button [disabled]="readOnlyVisualizar" icon="pi pi-user" label="Añadir contacto"
                    [style]="{ 'width': '100%', 'display': 'flex', 'align-items': 'center'}"
                    (click)="openModalContacto(contactoComponent, 'contacto')" *ngIf="listaContactoJ.length === 0">
                  </p-button>
                </div>
                <div class="card a-example-full-width-alterno-content-4" style="align-items: center;">
                  <div class="a-checkbox ">
                    <p-checkbox [ngClass]="{ readonly: readOnlyVisualizar }" formControlName="cotizacionpropia"
                      [binary]="true" inputId="binary" appendTo="body">
                    </p-checkbox>
                    <label class="ml-2">Cotización Propia</label>
                  </div>
                </div>
                <!-- <div class="card a-example-full-width-alterno-content-4" style="align-items: center;"> //18-06
                  <div class="a-checkbox ">
                    <p-checkbox [ngClass]="{ readonly: readOnlyVisualizar }" formControlName="serviciologistico"
                      [binary]="true" inputId="binary" appendTo="body">
                    </p-checkbox>
                    <label class="ml-2">Servicio Logistico</label>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                    [options]="ListaTodosAgentes" placeholder="‎ " optionLabel="nombre" formControlName="agente"
                    optionValue="nombre" appendTo="body" [filter]="true" [showClear]="true" styleClass="w-full md:w-56"
                    (onChange)="cargarLNGAgente($event)" (onChange)="onAgenteChange($event)">
                  </p-select>
                  <label for="on_label">Agente</label>
                </p-floatlabel>
              </div>
              <div class="a-example-full-width-alterno-content-2">

                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                    [options]="ListaTodosCustomer" placeholder="‎ " optionLabel="nombre" formControlName="customer"
                    optionValue="nombre" appendTo="body" [filter]="true" [showClear]="true"
                    (onChange)="onCustomerChange($event)" styleClass="w-full md:w-56">
                  </p-select>
                  <label for="on_label">Customer</label>
                </p-floatlabel>
              </div>
            </div>
            <div class="a-example-full-width-alterno-content-row">

              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                    [options]="ListaTodosEjecutivos" placeholder="‎ " optionLabel="nombre" formControlName="ejecutivo"
                    optionValue="nombre" appendTo="body" [filter]="true" [showClear]="true"
                    (onChange)="onEjecutivoChange($event)" styleClass="w-full md:w-56">
                  </p-select>
                  <label for="on_label">Ejecutivo</label>
                </p-floatlabel>
              </div>
            </div>
          </div>
        </form>

        <div class=".a-example-full-width-alterno-content" style="margin-top: 1%;">
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
            <p-button #botonSiguiente type="button" class="btn guardar-button" (click)="onTabDatosGenerales($event)">
              <i class="pi pi-arrow-right" style="margin-right: 8px;"></i> Siguiente
            </p-button>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Datos Generales">
        <p-accordion [multiple]="true">
          <form [formGroup]="group_datosGenerales">
            <p-toast key="tl" appendTo="body" position="bottom-right"></p-toast>
            <p-confirmdialog key="C" />
            <p-accordionTab header="Tarifas" [selected]="true">
              <p-confirmdialog key="T" />
              <div class="a-example-full-width-alterno-content-column">
                <div class="a-example-full-width-alterno-content-column-2">
                  <div class="a-example-full-width-alterno-content-row">

                    <div class="a-example-full-width-alterno-content-2">
                      <div style="display: flex; align-items: center;">
                        <p-floatlabel class="w-full md:w-56" variant="on" style="flex: 1;">
                          <p-select inputId="on_label" #autocompleteTransportista
                            [ngClass]="{'ng-invalid ng-dirty': this.group_datosGenerales.get('transportista')?.invalid && (this.group_datosGenerales.get('transportista')?.touched), readonly: readOnlyVisualizar }"
                            [options]="ListaTodosTransportista" placeholder="‎ " optionLabel="nombre"
                            formControlName="transportista" optionValue="nombre" appendTo="body" [filter]="true"
                            [showClear]="true" styleClass="w-full md:w-56" (onChange)="onTransporteChange($event)"
                            (onHide)="onDropdownHideTransportista()">
                          </p-select>
                          <label for="on_label">Transportista</label>
                        </p-floatlabel>
                        <p-button *ngIf="mostrarBotonTransportista" type="button" class="btn buscar-button"
                          [style]="{'margin-left': '10px'}"
                          (click)="visualizarTransportista(transportistasComponent, 'transportista')">
                          <i class="pi pi-user"></i>
                        </p-button>
                      </div>
                      <small
                        *ngIf="this.group_datosGenerales.get('transportista')?.invalid && (this.group_datosGenerales.get('transportista')?.touched)"
                        class="text-red-500">
                        Este campo es obligatorio
                      </small>
                    </div>

                    <div class="a-example-full-width-alterno-content-3">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select inputId="on_label" #dropdownPuertoOrigen [ngClass]="{ readonly: readOnlyVisualizar }"
                          [options]="ListaTodosPuertoOrigenyDestino" placeholder="‎ " optionLabel="nombre"
                          formControlName="puertoorigen" optionValue="codigo" appendTo="body" [filter]="true"
                          [showClear]="true" [virtualScroll]="true" styleClass="w-full md:w-56"
                          (onChange)="onPuertoChange($event)" (onHide)="onDropdownHidePuertoOrigen()">
                        </p-select>
                        <label for="on_label">Puerto Origen</label>
                      </p-floatlabel>
                    </div>

                    <div class="a-example-full-width-alterno-content-3">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select inputId="on_label" #dropdownPuertoDestino [ngClass]="{ readonly: readOnlyVisualizar }"
                          [options]="ListaTodosPuertoOrigenyDestino" placeholder="‎ " optionLabel="nombre"
                          formControlName="puertodestino" optionValue="codigo" appendTo="body" [filter]="true"
                          [showClear]="true" [virtualScroll]="true" styleClass="w-full md:w-56"
                          (onHide)="onDropdownHidePuertoDestino()">
                        </p-select>
                        <label for="on_label">Puerto Destino</label>
                      </p-floatlabel>
                    </div>

                  </div>

                  <div class="a-example-full-width-alterno-content-column-2">
                    <div class="a-example-full-width-alterno-content-row">
                      <div class="card a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-select inputId="on_label" #dropdownContenedor [ngClass]="{ readonly: readOnlyVisualizar }"
                            [options]="ListaTipoPaquete" placeholder="‎ " optionLabel="nombre"
                            formControlName="contenedor" optionValue="codigo" appendTo="body" [filter]="true"
                            [showClear]="true" styleClass="w-full md:w-56" (onChange)="onContenedorChange($event)"
                            (onHide)="onDropdownHideContenedor()">
                          </p-select>
                          <label for="on_label">Contenedor</label>
                        </p-floatlabel>
                      </div>
                      <div class="card a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <input inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" pInputText
                            formControlName="cantidad" appendTo="body" min="0" class="w-full md:w-56" />
                          <label for="on_label">Cantidad</label>
                        </p-floatlabel>
                      </div>

                      <div class="a-example-full-width-alterno-content-6">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                            [options]="ListaTodosMoneda" placeholder="‎ " optionLabel="nombre" formControlName="moneda"
                            optionValue="codigo" appendTo="body" styleClass="w-full md:w-56">
                          </p-select>
                          <label for="on_label">Moneda</label>
                        </p-floatlabel>
                      </div>

                      <div class="a-example-full-width-alterno-content-6">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                            [options]="ListaTodosPuertoOrigenyDestino" placeholder="‎ " optionLabel="nombre"
                            formControlName="puertotransbordo" optionValue="codigo" appendTo="body" [filter]="true"
                            [showClear]="true" [virtualScroll]="true" styleClass="w-full md:w-56">
                          </p-select>
                          <label for="on_label">Puerto Transbordo</label>
                        </p-floatlabel>
                      </div>


                      <div class="a-example-full-width-alterno-content-6">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                            [options]="ListaTodosTrafico" placeholder="‎ " optionLabel="nombre"
                            formControlName="trafico" optionValue="codigo" appendTo="body" styleClass="w-full md:w-56">
                          </p-select>
                          <label for="on_label">Trafico</label>
                        </p-floatlabel>
                      </div>
                      <div class="a-example-full-width-alterno-content-6">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                            [options]="ListaTodosCondicion" placeholder="‎ " optionLabel="nombre"
                            formControlName="condicion" optionValue="codigo" appendTo="body" styleClass="w-full md:w-56"
                            (onChange)="onCondicionChange($event)">
                          </p-select>
                          <label for="on_label">Condición</label>
                        </p-floatlabel>
                      </div>


                    </div>
                    <div class="a-example-full-width-alterno-content-row">

                      <div class="card a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                            [options]="ListaTodosTipoFechaTarifa" placeholder="‎ " optionLabel="nombre"
                            formControlName="tipofechatarifa" optionValue="codigo" appendTo="body"
                            styleClass="w-full md:w-56">
                          </p-select>
                          <label for="on_label">Tipo Fecha Tarifa</label>
                        </p-floatlabel>
                      </div>

                      <div class="card a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-datepicker inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                            formControlName="fechatarifa" appendTo="body" [showIcon]="true" [showWeek]="false"
                            styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [showOnFocus]="false"
                            [readonlyInput]="false" (onInput)="formatDateInput($event)">
                          </p-datepicker>
                          <label for="on_label">F. Tarifa</label>
                        </p-floatlabel>
                      </div>


                      <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56" variant="on"
                          style="flex: 1; display: flex; align-items: center;">
                          <input inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" pInputText
                            formControlName="numerocontrato" appendTo="body" class="w-full md:w-56"
                            (onChange)="onNumeroContratoChange($event)" />
                          <label for="on_label">Número Contrato</label>
                          <p-button #botonContrato [disabled]="readOnlyVisualizar" type="button"
                            class="btn buscar-button" [style]="{'margin-left': '10px'}"
                            (click)="buscarContratoAyudaPivot(contratoComponent, 'contrato')">
                            <i class="pi pi-search"></i>
                          </p-button>
                        </p-floatlabel>
                      </div>

                      <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <input inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" pInputText
                            formControlName="adicional" appendTo="body" class="w-full md:w-56" />
                          <label for="on_label">Descripción</label>
                        </p-floatlabel>
                      </div>

                    </div>

                  </div>

                  <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-0_5">
                      <app-datatable [dataTable]="serviciosytarifas_dataflete" [metadataTable]="metadatableFlete"
                        [colorBtnDel]="true" [rowEdit]="true" [addRow]="true" [rowDelete]="true" [style]="estilos"
                        [title]="'Flete'" [colorBtnEdit]="true" [key]="'key'"
                        (checkboxChange)="onCheckboxChange($event)" [resaltarCabecera]="true" [colorBtnMas]="true"
                        #dataFlete (onDpChangeEvento)="onChangeFletes($event)"
                        [onDpValueChangeEvento]="onDpValueChangeFleteEvento"
                        (onInputChangeEvento)="onChangeFletes($event)" (saveEdit)="calculateFlete($event)">
                      </app-datatable>
                    </div>
                    <div class="a-example-full-width-alterno-content-4">
                      <div class="a-example-full-width-alterno-content-column-2">
                        <div class="a-example-full-width-alterno-content-row">
                          <div class="a-example-full-width-alterno-content-2">
                            <p-floatlabel class="w-full md:w-56" variant="on">
                              <p-select inputId="on_label"
                                [ngClass]="{'ng-invalid ng-dirty': this.group_datosGenerales.get('pcmbl')?.invalid && (this.group_datosGenerales.get('pcmbl')?.touched), readonly: readOnlyVisualizar }"
                                [options]="ListaTodosPCMBL" placeholder="‎ " optionLabel="nombre"
                                formControlName="pcmbl" optionValue="codigo" appendTo="body"
                                styleClass="w-full md:w-56">
                              </p-select>
                              <label for="on_label">P/C (MBL)</label>
                            </p-floatlabel>
                            <small
                              *ngIf="this.group_datosGenerales.get('pcmbl')?.invalid && (this.group_datosGenerales.get('pcmbl')?.touched)"
                              class="text-red-500">
                              Este campo es obligatorio
                            </small>
                          </div>

                          <div class="a-example-full-width-alterno-content-2">
                            <p-floatlabel class="w-full md:w-56" variant="on">
                              <p-select inputId="on_label"
                                [ngClass]="{'ng-invalid ng-dirty': this.group_datosGenerales.get('pchbl')?.invalid && (this.group_datosGenerales.get('pchbl')?.touched), readonly: readOnlyVisualizar }"
                                [options]="ListaTodosPCHBL" placeholder="‎ " optionLabel="nombre"
                                formControlName="pchbl" optionValue="codigo" appendTo="body"
                                styleClass="w-full md:w-56">
                              </p-select>
                              <label for="on_label">P/C (HBL)</label>
                            </p-floatlabel>
                            <small
                              *ngIf="this.group_datosGenerales.get('pchbl')?.invalid && (this.group_datosGenerales.get('pchbl')?.touched)"
                              class="text-red-500">
                              Este campo es obligatorio
                            </small>
                          </div>
                        </div>
                        <div class="a-example-full-width-alterno-content-row">
                          <div class="a-example-full-width-alterno-content-2">
                            <p-floatlabel class="w-full md:w-56" variant="on">
                              <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                                formControlName="fletetotal" mode="decimal" [showButtons]="true" [useGrouping]="false"
                                [min]="0" [inputStyle]="{ width: '100%' }" class="w-full md:w-56">
                              </p-inputNumber>
                              <label for="on_label">Flete Total</label>
                            </p-floatlabel>
                          </div>

                          <div class="a-example-full-width-alterno-content-2">
                            <p-floatlabel class="w-full md:w-56" variant="on">
                              <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                                formControlName="diaslibres" mode="decimal" [showButtons]="true" [useGrouping]="false"
                                [min]="0" [inputStyle]="{ width: '100%' }" class="w-full md:w-56">
                              </p-inputNumber>
                              <label for="on_label">Dias Libres Sobreestadia</label>
                            </p-floatlabel>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </p-accordionTab>

            <p-accordionTab header="Servicios Locales" [selected]="true">
              <form [formGroup]="group_tarifasAdicionales">

                <div style="margin-top: 1%;"></div>
                <div class="a-example-full-width-alterno-content-column">
                  <div class="a-example-full-width-alterno-content-row">
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-5">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input for="float-label" pInputText formControlName="codigooperacion"
                          [ngClass]="{ readonly: readOnlyCodigoOperacionDSL }" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Código operación</label>
                      </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-5">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input for="float-label" pInputText formControlName="numerooperacion"
                          [ngClass]="{ readonly: readOnlyNumeroOpeacionDSL }" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Número operación</label>
                      </p-floatlabel>
                    </div>
                    <!-- <div class="card flex justify-content-center a-example-full-width-alterno-content-4">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input inputId="on_label" [ngClass]="{ readonly: readOnlyClienteDSL }" pInputText
                          formControlName="clienteDSL" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Cliente</label>
                      </p-floatlabel>
                    </div> -->

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-4"> <p-floatlabel
                        class="w-full md:w-56 bold-floatlabel" variant="on">
                        <p-select inputId="on_label" [options]="ListaTodosCliente" placeholder="‎ " optionLabel="nombre"
                          formControlName="clienteDSL" optionValue="codigo" appendTo="body" [filter]="true"
                          styleClass="w-full md:w-56" virtualScroll="true" virtualScrollItemSize="36" size="small">
                        </p-select>
                        <label for="on_label">Cliente</label>
                      </p-floatlabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-4">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input inputId="on_label" [ngClass]="{ readonly: readOnlyTransportistaAMDSL }" pInputText
                          formControlName="transportistaam" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Transportista (A/M)</label>
                      </p-floatlabel>
                    </div>
                  </div>

                  <div class="a-example-full-width-alterno-content-row">
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-5">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyFechaEmisionDSL }"
                          formControlName="fechaemision" appendTo="body" [showIcon]="true" [showWeek]="false"
                          dateFormat="dd/mm/yy" (onChange)="onFechaEmiChange($event)" [showOnFocus]="false"
                          [readonlyInput]="false" (onInput)="formatDateInput($event)" styleClass="w-full md:w-56">
                        </p-datepicker>
                        <label for="on_label">Fecha Operación</label>
                      </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-5">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input inputId="on_label" [ngClass]="{ readonly: readOnlyCondicionEmbarqueDSL }" pInputText
                          formControlName="condicion" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Condición embarque</label>
                      </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-4">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input inputId="on_label" [ngClass]="{ readonly: readOnlyAgenciaMaritimaDSL }" pInputText
                          formControlName="agencia" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Agencia marítima</label>
                      </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-4">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyAlmacenDSL }"
                          [ngClass]="{ readonly: readonlyDepositoNov }" [options]="ListaTodosDeposito"
                          optionLabel="nombre" formControlName="deposito" optionValue="nombre" appendTo="body"
                          [filter]="true" [showClear]="true" styleClass="w-full md:w-56"
                          (onChange)="onDepositoChange($event)">
                        </p-select>
                        <label for="on_label">Almacén</label>
                      </p-floatlabel>
                    </div>
                  </div>
                  <div class="a-example-full-width-alterno-content-row">
                    <!-- <div class="card flex justify-content-center a-example-full-width-alterno-content-5">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-datepicker inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                          formControlName="vigenciadesde" appendTo="body" [showIcon]="true" [showWeek]="false"
                          dateFormat="dd/mm/yy" [showOnFocus]="false" [readonlyInput]="false"
                          (onInput)="formatDateInput($event)" styleClass="w-full md:w-56">
                        </p-datepicker>
                        <label for="on_label">Vigencia desde</label>
                      </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-5">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-datepicker inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                          formControlName="vigenciahasta" appendTo="body" [showIcon]="true" [showWeek]="false"
                          dateFormat="dd/mm/yy" [showOnFocus]="false" [readonlyInput]="false"
                          (onInput)="formatDateInput($event)" styleClass="w-full md:w-56">
                        </p-datepicker>
                        <label for="on_label">Vigencia hasta</label>
                      </p-floatlabel>
                    </div> -->
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-4">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                          [options]="ListaTodosTransportista" optionLabel="nombre" formControlName="transportistaTerre"
                          optionValue="codigo" appendTo="body" [filter]="true" [showClear]="true"
                          styleClass="w-full md:w-56" (onChange)="onTransTerrChange($event)">
                        </p-select>
                        <label for="on_label">Transportista (T)</label>
                      </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-4">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input inputId="on_label" [ngClass]="{ readonly: readOnlyTerminalPortuarioDSL }" pInputText
                          formControlName="terminal" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Terminal portuario</label>
                      </p-floatlabel>
                    </div>
                  </div>
                  <div class="a-example-full-width-alterno-content-row">
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-5">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <input inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" pInputText
                          formControlName="tipo" appendTo="body" class="w-full md:w-56" />
                        <label for="on_label">Tipo</label>
                      </p-floatlabel>
                    </div>
                    <div class="InputSwitch a-example-full-width-alterno-content-5">
                      <p-inputSwitch [ngClass]="{ readonly: readonlySADADSL }" formControlName="sada" />SADA
                    </div>
                    <div class="InputSwitch a-example-full-width-alterno-content-5">
                      <p-inputSwitch [ngClass]="{ readonly: readonlyIMODSL }" formControlName="imo" />IMO
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                      <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                        <p-select [options]="listRutas" placeholder="‎ " optionLabel="label" formControlName="rutas"
                          optionValue="value" appendTo="body" [filter]="true" [showClear]="true"
                          styleClass="w-full md:w-56" size="small">
                        </p-select>
                        <label for="on_label">Rutas</label>
                      </p-floatlabel>
                    </div>
                    <p-button label="" (onClick)="verZonas()" icon="pi pi-eye" pTooltip="Visualizar Zonas"></p-button>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                      <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                        <p-inputNumber inputId="on_label" formControlName="cifEjecVta" [showButtons]="true"
                          (onInput)="onChangeCif('EVE','EJEC')" [useGrouping]="false" [inputStyle]="{ width: '100%' }"
                          class="w-full md:w-56" size="small">
                        </p-inputNumber>
                        <label for="on_label">Monto CIF (Ejecutivo)</label>
                      </p-floatLabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                      <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                        <p-inputNumber inputId="on_label" formControlName="cifLogistico" [showButtons]="true"
                          (onInput)="onChangeCif('EVE', 'LOG')" [useGrouping]="false" [inputStyle]="{ width: '100%' }"
                          class="w-full md:w-56" size="small">
                        </p-inputNumber>
                        <label for="on_label">Monto CIF (Logistico)</label>
                      </p-floatLabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                      <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                        <p-inputNumber inputId="on_label" formControlName="montodam" [showButtons]="true"
                          [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56" size="small">
                        </p-inputNumber>
                        <label for="on_label">Monto DAM</label>
                      </p-floatLabel>
                    </div>
                  </div>

                  <!-- <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-column">
                      <p-fieldset legend="Agregar Servicios" class="a-w1">
                        <div class="a-w1-row">
                          <div class="a-w4">
                            <div class="a-w1">
                              <p-floatlabel class="w-full md:w-56" variant="on">
                                <p-select [options]="ListaTodosServicios" optionLabel="nombre"
                                  formControlName="servicio" optionValue="codigo" styleClass="w-full md:w-56"
                                  [filter]="true" [showClear]="true" filterBy="nombre" [appendTo]="'body'">
                                </p-select>
                                <label for="on_label">Servicio</label>
                              </p-floatlabel>
                            </div>
                            <div class="a-w1" style="padding-top: 20px; display: flex; justify-content: right;">
                              <p-button label="Agregar Servicio" (onClick)="AddServicio()"></p-button>
                            </div>
                          </div>
                          <div class="a-w4-diference">
                            <div class="a-w1">
                              <app-datatable [dataTable]="servicioslocales_tarifa" [metadataTable]="metadatableTarifa"
                                [filter]="true" [filterGlobal]="true" [paginacion]="false"
                                (checkboxChange)="onCheckboxChangeTarifas($event)" [customButtons]="custombTarifas">
                              </app-datatable>
                            </div>
                          </div>
                        </div>
                      </p-fieldset>
                    </div> -->
                  <!-- <p-tabView class="a-example-full-width-alterno-content">
                      <p-tabPanel header="Tarifas">
                        <div class="a-example-full-width-alterno-content" style="position: relative;" *ngIf="bloqueoCheckboxSLI=='nolock'">
                          <app-datatable [dataTable]="servicioslocales_tarifa" [metadataTable]="metadatableTarifa"
                            [filter]="true" [filterGlobal]="true" [paginacion]="false" [resaltarCabecera]="true"
                            (checkboxChange)="onCheckboxChangeTarifas($event)" [customButtons]="custombTarifas"
                            [disableAddRow]="bloqueoObservaciones" [disableDeleteRow]="bloqueoObservaciones"
                            [disableEditRow]="bloqueoObservaciones">
                          </app-datatable>
                        </div>
                      </p-tabPanel>
                      <p-tabPanel header="Descripción">
                        <textarea [ngClass]="{ readonly: readonlyDescripcionDSL }" id="float-input" rows="5" cols="30"
                          pInputTextarea formControlName="descripcion" style="width: 100%;"></textarea>
                      </p-tabPanel>
                      <p-tabPanel header="Observación">
                        <div class="a-example-full-width-alterno-content">
                          <app-datatable [dataTable]="servicioslocales_dataObservaciones"
                            [metadataTable]="metadatableDataObservaciones" [filter]="true">
                          </app-datatable>
                        </div>
                      </p-tabPanel>
                    </p-tabView> -->
                  <!-- </div> -->
                </div>

                <div class="a-w1-row" style="padding-top: 20px;">
                  <div class="a-w4">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                      <p-datepicker inputId="on_label" formControlName="fechasl" appendTo="body" [showIcon]="true"
                        [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false" [readonlyInput]="false"
                        styleClass="w-full md:w-56">
                      </p-datepicker>
                      <label for="on_label">Fecha SL</label>
                    </p-floatlabel>
                  </div>

                  @if(this.rol === '1') {
                  <div class="w-auto flex gap-4 align-content-center">
                    <p-checkbox formControlName="promedio" [binary]="true" inputId="binary" appendTo="body"
                      size="small">
                    </p-checkbox>
                    <label>Promedio</label>
                  </div>
                  }

                  <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                    <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                      <p-inputNumber inputId="peso" formControlName="peso" [showButtons]="true" [useGrouping]="false"
                        [inputStyle]="{ width: '100%' }" class="w-full md:w-56" size="small">
                      </p-inputNumber>
                      <label for="peso">Peso</label>
                    </p-floatLabel>
                  </div>

                  <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                      <p-select inputId="unmd_peso" [options]="ListaUnidadMedida" placeholder="‎ " optionLabel="label"
                        formControlName="unmd_peso" optionValue="value" appendTo="body" [filter]="true"
                        [showClear]="true" styleClass="w-full md:w-56" size="small">
                      </p-select>
                      <label for="unmd_peso">Unidad de medida (peso)</label>
                    </p-floatlabel>
                  </div>

                  <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                    <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                      <p-inputNumber inputId="volumen" formControlName="volumen" [showButtons]="true"
                        [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56" size="small">
                      </p-inputNumber>
                      <label for="volumen">Volumen</label>
                    </p-floatLabel>
                  </div>

                  <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                      <p-select inputId="unmd_volumen" [options]="ListaUnidadMedida" placeholder="‎ "
                        optionLabel="label" formControlName="unmd_volumen" optionValue="value" appendTo="body"
                        [filter]="true" [showClear]="true" styleClass="w-full md:w-56" size="small">
                      </p-select>
                      <label for="unmd_volumen">Unidad de medida (volumen)</label>
                    </p-floatlabel>
                  </div>

                  <p-button label="Buscar Tarifa" (onClick)="searchTarifa()" [disabled]="!modovisualizar"></p-button>
                  <p-button label="Ver Tarifario" (onClick)="verTarifarioSli()"
                    [disabled]="esVisualizar == true ? esVisualizar : !modovisualizar" class="btn-sli"></p-button>
                  <p-button [disabled]="agrupar" label="Agrupar" (onClick)="AgruparPoppup()"></p-button>
                  <p-button [disabled]="desagrupar" label="Desagrupar" (onClick)="desagruparServicio()"></p-button>
                  <!-- <p-button label="Crear Orden de Servicio" (onClick)="crearOrdenServicio()"></p-button> -->
                </div>

                <div style="margin-top: 1%;"></div>
                <div class="a-example-full-width-alterno-content-column">
                  <div class="a-example-full-width-alterno-content">
                    <app-datatable [dataTable]="servicioslocales_datadetalle" [metadataTable]="metadatableDataDetalle"
                      [btnDisabled]="!modovisualizar" [key]="'key'" [blockedColumnsEdit]="bloqueoColumnas"
                      [customButtons]="reset" [rowEdit]="modovisualizar" #dtServiciosRef [colorBtnEdit]="true"
                      [editDisabled]="edicion === true || !desagrupar" (rowEditInit)="onEditRowInit($event)"
                      [colorBtnDel]="true" [resaltarCabecera]="true" [disableAddRow]="bloqueoObservaciones"
                      [disableDeleteRow]="bloqueoObservaciones" [disableEditRow]="bloqueoObservaciones"
                      [customLeyendasHex]="leyendasAgrupacionRow" (saveEdit)="mapearEdit($event)">
                      <ng-template #addHeaderStart>
                        @if (modovisualizar) {
                        <th class="header">Acción</th>
                        }
                        @else{
                        <th class="header">Leyenda</th>
                        }
                      </ng-template>

                      <ng-template #addBodyStart let-row="row">
                        @if (modovisualizar) {
                        <td class="a-datatable-datos-body-accion row-space">
                          @if (modovisualizar) {
                          <p-checkbox [inputId]="row.key" name="group2" [value]="row.key"
                            (onChange)="addTarifa($event, row, 'A', null)" [disabled]="!desagrupar" />
                          }

                          @if (row?.agrupado != true) {
                          <p-button (onClick)="eliminarServicio(row, 'D')" icon="pi pi-trash" pTooltip="Eliminar"
                            [disabled]="edicion || !desagrupar">
                          </p-button>
                          }
                        </td>
                        }
                        @else {
                        <td class="a-datatable-datos-body-accion row-space">
                          <div class="leyenda-icon-container">
                            <div class="leyenda-icon-table" [style.background]="colorLeyendasAgrupacion(row)"></div>
                          </div>
                        </td>
                        }
                      </ng-template>
                    </app-datatable>
                  </div>
                  <div class="a-example-full-width-alterno-content">
                    <app-datatable [dataTable]="servicioslocales_detalleAgrupacion"
                      [btnDisabled]="!modovisualizar || !desagrupar || edicion"
                      [metadataTable]="metadataTableDetalleAgrupacion" [key]="'key'">
                      <ng-template #addHeaderStart>
                        <th class="header" *ngIf="modovisualizar">
                          <div class="items-header">
                            <span>Acción</span>
                          </div>
                        </th>
                      </ng-template>
                      <ng-template #addBodyStart let-row="row">
                        <td class="a-datatable-datos-body-accion row-space" *ngIf="modovisualizar">
                          <p-checkbox [inputId]="row.key" name="group2" [value]="row.key"
                            (onChange)="addTarifa($event,row, 'D',null)" [disabled]="edicion" />
                          <p-button (onClick)="eliminarServicio(row,'A')" icon="pi pi-trash" pTooltip="Eliminar"
                            [disabled]="edicion || !desagrupar"></p-button>
                        </td>
                      </ng-template>
                    </app-datatable>
                  </div>
                </div>

              </form>
            </p-accordionTab>

            <p-accordionTab header="Servicios" [selected]="false">
              <div class="a-example-full-width-alterno-content-column">
                <div class="a-example-full-width-alterno-content-column-2">
                  <div class="a-example-full-width-alterno-content">
                    <app-datatable [dataTable]="serviciosytarifas_dataservicios" [metadataTable]="metadatableServicio"
                      [addRow]="true" [rowEdit]="true" [rowDelete]="true" [style]="estilos" [title]="'Servicios'"
                      [key]="'scot_item'" [colorBtnDel]="true" [colorBtnMas]="true" [colorBtnEdit]="true"
                      [resaltarCabecera]="true">
                    </app-datatable>
                  </div>
                </div>

              </div>
            </p-accordionTab>

            <form [formGroup]="group_datosAdicionales">


              <p-accordionTab header="Datos Embarque" [selected]="false">

                <div class="a-example-full-width-alterno-content-column">

                  <p-fieldset legend="Datos de contrato" class="a-example-full-width-alterno-content">
                    <div class="a-example-full-width-alterno-content-column">
                      <div class="a-example-full-width-alterno-content-row">
                        <div class="a-checkbox a-example-full-width-alterno-content-3">
                          <p-checkbox [ngClass]="{ readonly: readOnlyVisualizar }" formControlName="cargarefrigerada"
                            [binary]="true" inputId="binary" appendTo="body">
                          </p-checkbox>
                          <label>Carga Refrigerada</label>
                        </div>

                        <div class="a-example-full-width-alterno-content-3">
                          <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }"
                              formControlName="temperatura" mode="decimal" [showButtons]="true" [useGrouping]="false"
                              [inputStyle]="{ width: '100%' }" class="w-full md:w-56">
                            </p-inputNumber>
                            <label for="on_label">Temperatura (C°)</label>
                          </p-floatlabel>
                        </div>

                        <div class="a-checkbox a-example-full-width-alterno-content-3">
                          <p-checkbox [ngClass]="{ readonly: readOnlyVisualizar }" formControlName="cargapeligrosa"
                            [binary]="true" inputId="binary" appendTo="body"
                            (onChange)="onCargaPeligrosaChange($event)">
                          </p-checkbox>
                          <label>Carga Peligrosa</label>
                        </div>

                        <div class="a-example-full-width-alterno-content-4">
                          <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlyImoClassDE }"
                              [options]="ListaTodosImoClass" placeholder="‎ " optionLabel="nombre"
                              formControlName="imoclass" optionValue="codigo" appendTo="body"
                              styleClass="w-full md:w-56" font-size="8px">
                            </p-select>
                            <label for="on_label">IMO Class</label>
                          </p-floatlabel>
                        </div>

                        <div class="a-checkbox a-example-full-width-alterno-content-3">
                          <p-checkbox formControlName="roundtrip" [binary]="true" inputId="binary" appendTo="body">
                          </p-checkbox>
                          <label>RoundTrip</label>
                        </div>

                        <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                          <p-floatlabel class="w-full md:w-56" variant="on">
                            <input for="float-label" pInputText formControlName="imoun" appendTo="body"
                              [ngClass]="{ readonly: readOnlyImoUnDE }" class="w-full md:w-56" />
                            <label for="on_label">IMO UN</label>
                          </p-floatlabel>
                        </div>
                      </div>
                    </div>
                  </p-fieldset>

                  <p-fieldset legend="Datos adicionales" class="a-example-full-width-alterno-content">
                    <div class="a-example-full-width-alterno-content-column a-example-full-width-alterno-content">

                      <div class="a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content">
                          <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}"
                              [options]="ListaTodosShipper" placeholder="‎ " optionLabel="nombre"
                              formControlName="shipper" optionValue="nombre" appendTo="body" [filter]="true"
                              [showClear]="true" styleClass="w-full md:w-56" [virtualScroll]="true"
                              (onChange)="onShipperChange($event)">
                            </p-select>
                            <label for="on_label">Shipper</label>
                          </p-floatlabel>
                        </div>
                      </div>
                      <div class="a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-row">
                          <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
                            <textarea inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" id="float-input"
                              rows="5" cols="30" pTextarea formControlName="desc_shipper" style="width: 100%"
                              class="w-full md:w-56" pSize="small" placeholder="‎ ">
                                </textarea>
                            <label for="on_label">Shipper Descripción</label>
                          </p-floatlabel>
                        </div>
                      </div>
                      <div class="a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content">
                          <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}"
                              [options]="ListaTodosConsignee" placeholder="‎ " optionLabel="nombre"
                              formControlName="consignee" optionValue="nombre" appendTo="body" [filter]="true"
                              [showClear]="true" styleClass="w-full md:w-56" [virtualScroll]="true"
                              (onChange)="onConsigneeChange($event)">
                            </p-select>
                            <label for="on_label">Consignee</label>
                          </p-floatlabel>
                        </div>
                      </div>
                      <div class="a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-row">
                          <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
                            <textarea inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar }" id="float-input"
                              rows="5" cols="30" pTextarea formControlName="desc_consignee" style="width: 100%"
                              class="w-full md:w-56" pSize="small" placeholder="‎ ">
                                </textarea>
                            <label for="on_label">Consignee Descripción</label>
                          </p-floatlabel>
                        </div>
                      </div>
                      <div class="a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content">
                          <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}"
                              [options]="ListaTodosNotify" placeholder="‎ " optionLabel="nombre"
                              formControlName="notify" optionValue="nombre" appendTo="body" [filter]="true"
                              [showClear]="true" styleClass="w-full md:w-56" [virtualScroll]="true"
                              (onChange)="onNotifyChange($event)">
                            </p-select>
                            <label for="on_label">Notify</label>
                          </p-floatlabel>
                        </div>
                      </div>
                      <div class="a-example-full-width-alterno-content-row">
                        <div class="card flex justify-content-center a-example-full-width-alterno-content">
                          <p-floatlabel class="w-full md:w-56" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}" pInputText
                              formControlName="referencia" appendTo="body" class="w-full md:w-56" />
                            <label for="on_label">Referencia</label>
                          </p-floatlabel>
                        </div>
                      </div>
                    </div>
                  </p-fieldset>
                </div>
                <div class="titulo_secciones">Flete</div>
                <div class="a-example-full-width-alterno-content">
                  <app-datatable [dataTable]="datosembarque_dataflete" [metadataTable]="metadatableFleteEmbarque"
                    [filter]="true" [addRow]="true" [rowEdit]="true" [style]="estilos" [title]="' '" [key]="'dcot_item'"
                    [colorBtnMas]="true" [colorBtnEdit]="true" [resaltarCabecera]="true">
                  </app-datatable>
                </div>

              </p-accordionTab>
              <p-accordionTab header="Observaciones" [selected]="false">

                <div class="a-example-full-width-alterno-content-column">
                  <div class="a-example-full-width-alterno-content">
                    <div class="a-example-full-width-alterno-content-row">
                      <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}"
                            formControlName="almacenaje" mode="decimal" [showButtons]="true" [useGrouping]="false"
                            [inputStyle]="{ width: '100%' }" class="w-full md:w-56">
                          </p-inputNumber>
                          <label for="on_label">Almacenaje (días)</label>
                        </p-floatlabel>
                      </div>

                      <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}"
                            formControlName="tiempoviaje" mode="decimal" [showButtons]="true" [useGrouping]="false"
                            [inputStyle]="{ width: '100%' }" class="w-full md:w-56">
                          </p-inputNumber>
                          <label for="on_label">Tiempo viaje (dias)</label>
                        </p-floatlabel>
                      </div>
                      <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}"
                            formControlName="sobreestadia" mode="decimal" [showButtons]="true" [useGrouping]="false"
                            [inputStyle]="{ width: '100%' }" class="w-full md:w-56">
                          </p-inputNumber>
                          <label for="on_label">Sobreestadia (días)</label>
                        </p-floatlabel>
                      </div>

                      <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                          <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyVisualizar}"
                            formControlName="validezoferta" mode="decimal" [showButtons]="true" [useGrouping]="false"
                            [inputStyle]="{ width: '100%' }" class="w-full md:w-56">
                          </p-inputNumber>
                          <label for="on_label">Validez oferta (dias)</label>
                        </p-floatlabel>
                      </div>
                    </div>
                  </div>
                  <div class="a-example-full-width-alterno-content">
                    <div class="a-example-full-width-alterno-content-row">
                      <p-floatlabel class="w-full md:w-56" variant="on">
                        <textarea id="float-input" rows="5" cols="30" pTextarea formControlName="instrucciones"
                          style="width: 100%" class="w-full md:w-56"></textarea>
                        <label for="float-label">Instrucciones de embarque</label>
                      </p-floatlabel>
                    </div>
                  </div>
                </div>

              </p-accordionTab>

            </form>

          </form>

        </p-accordion>

      </p-tabPanel>

    </p-tabView>

  </div>
</div>
<footer>
  <div class="contenido-pie">
    <p></p>
  </div>
</footer>

<!-- <p-dialog header="Tarifas" [(visible)]="visible" [style]="{width: '80vw',height: '50vh'}" appendTo="body">
  <div class="a-w1">
    <app-datatable [dataTable]="dataTableDetalleAgrupado" [metadataTable]="metadataTableDetalleAgrupado">
    </app-datatable>
  </div>
</p-dialog> -->

<p-dialog header="Tarifas" [(visible)]="visibleTarifa" [style]="{width: '90vw',height: '90vh'}" appendTo="body">
  <p-toast key="tar" appendTo="body" position="bottom-right"></p-toast>
  <div class="a-w1">
    <p-accordion [multiple]="true">
      <p-accordionTab header="Servicio Logístico" [selected]="false">
        <div class="a-w1">
          <app-datatable [dataTable]="dataTableTarifaServicioLogistico"
            [metadataTable]="metadataTableTarifaServicioLogistico" [key]="'key'" [btnResetFiltros]="true"
            [btnResetFiltros]="true">
            <ng-template #addHeaderStart>
              <th class="header">
                <div class="items-header">
                  <span>Seleccionar</span>
                </div>
              </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-checkbox [inputId]="row.key" name="group" [value]="row.key"
                  (onChange)="addTarifa($event,row,'I','SLI')" />
              </td>
            </ng-template>
          </app-datatable>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Almacén" [selected]="false">
        <div class="a-w1">
          <app-datatable [dataTable]="dataTableTarifaAlmacen" [metadataTable]="metadataTableTarifaAlmacen" [key]="'key'"
            [styleRow]="styleRowAlm" [btnResetFiltros]="true" [btnResetFiltros]="true">
            <ng-template #addHeaderStart>
              <th class="header">
                <div class="items-header">
                  <span>Seleccionar</span>
                </div>
              </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-checkbox [inputId]="row.key" name="group" [value]="row.key"
                  (onChange)="addTarifa($event,row,'I','ALM')" />
              </td>
            </ng-template>
          </app-datatable>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Transporte" [selected]="false">
        <form [formGroup]="group_Transporte">
          <div class="a-w1">
            <div class="a-w3">
              <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select inputId="on_label" [options]="ListaTodosCondicion" optionLabel="nombre"
                  formControlName="condicion" optionValue="codigo" appendTo="body" styleClass="w-full md:w-56"
                  (onChange)="buscarTransporte($event)" [ngClass]="{ readonly: true }">
                </p-select>
                <label for="on_label">Condición</label>
              </p-floatlabel>
            </div>
          </div>
        </form>
        <div class="a-w1">
          <app-datatable [dataTable]="dataTableTransporte" [metadataTable]="metadataTableTransporte" [key]="'key'"
            [btnResetFiltros]="true" [btnResetFiltros]="true">
            <ng-template #addHeaderStart>
              <th class="header">
                <div class="items-header">
                  <span>Seleccionar</span>
                </div>
              </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-checkbox [inputId]="row.key" name="group" [value]="row.key"
                  (onChange)="addTarifa($event,row,'I','TNS')" />
              </td>
            </ng-template>
          </app-datatable>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Agenciamiento" [selected]="false">
        <div class="a-w1">
          <app-datatable [dataTable]="dataTableAgeAduana" [metadataTable]="metadataTableAgeAduana" [key]="'key'"
            [btnResetFiltros]="true" [btnResetFiltros]="true">
            <ng-template #addHeaderStart>
              <th class="header">
                <div class="items-header">
                  <span>Seleccionar</span>
                </div>
              </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-checkbox [inputId]="row.key" name="group" [value]="row.key"
                  (onChange)="addTarifa($event,row,'I','AGE')"
                  [disabled]="row?.concepto?.value === '003' && group_tabcotizacion.get('regimen')?.value === '001'" />
              </td>
            </ng-template>
          </app-datatable>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Tarifas Extra" [selected]="false">
        <div class="a-w1">
          <app-datatable [dataTable]="dataTableExtras" [metadataTable]="metadataTableExtras" [key]="'key'"
            [btnResetFiltros]="true" [btnResetFiltros]="true">
            <ng-template #addHeaderStart>
              <th class="header">
                <div class="items-header">
                  <span>Seleccionar</span>
                </div>
              </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-checkbox [inputId]="row.key" name="group" [value]="row.key"
                  (onChange)="addTarifa($event,row,'I','EXT')" />
              </td>
            </ng-template>
          </app-datatable>
        </div>
      </p-accordionTab>
      <p-accordionTab header="SLI – Tacna" [selected]="false">
        <div class="a-w1">
          <app-datatable [dataTable]="dataTableTc" [metadataTable]="metadataTableTc" [key]="'key'"
            [btnResetFiltros]="true" [btnResetFiltros]="true">
            <ng-template #addHeaderStart>
              <th class="header">
                <div class="items-header">
                  <span>Seleccionar</span>
                </div>
              </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-checkbox [inputId]="row.key" name="group" [value]="row.key"
                  (onChange)="addTarifa($event,row,'I','TC')" />
              </td>
            </ng-template>
          </app-datatable>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div class="a-w1" style="padding-top: 20px;">
    <p-button [disabled]="agrupar" label="Agrupar" (onClick)="AgruparPoppup()"></p-button>
  </div>
  <div class="a-w1" style="padding-top: 20px;">
    <app-datatable [dataTable]="servicioslocales_detalleTarifa" [metadataTable]="metadatableDetalleTarifa" [key]="'key'"
      [btnDisabled]="!modovisualizar" [customButtons]="reset" [blockedColumns]="bloqueoColumnas" [rowEdit]="false"
      [editDisabled]="edicion" #dtServiciosRef2 (rowEditInit)="onEditRowInit($event)" [filterGlobal]="true"
      [customLeyendasHex]="leyendasAgrupacionRow">

      <ng-template #addHeaderStart>
        @if (modovisualizar) {
        <th class="header">Acción</th>
        }
        @else {
        <th class="header">Leyenda</th>
        }
      </ng-template>

      <ng-template #addBodyStart let-row="row">

        @if (modovisualizar) {
        <td class="a-datatable-datos-body-accion row-space">
          @if (modovisualizar) {
          <p-checkbox [inputId]="row.key" name="group2" [value]="row.key" (onChange)="addTarifa($event, row, 'A', null)"
            [disabled]="!desagrupar" />
          }

          @if (row?.agrupado != true) {
          @if (!(['1', '10', '11', '14', this.coordLog, this.gerentLog]
          .includes(storage.get('rol')) && row.rol_usrcrea === '4')) {
          <p-button (onClick)="eliminarServicio(row, 'D')" icon="pi pi-trash" pTooltip="Eliminar">
          </p-button>
          }
          }
        </td>
        }
        @else {
        <td class="a-datatable-datos-body-accion row-space">
          <div class="leyenda-icon-container">
            <div class="leyenda-icon-table" [style.background]="colorLeyendasAgrupacion(row)">
            </div>
          </div>
        </td>
        }
      </ng-template>

    </app-datatable>

  </div>
  <div class="a-w1" style="padding-top: 20px;">
    <p-confirmPopup></p-confirmPopup>
    <app-datatable [dataTable]="servicioslocales_detalleAgrupacion" [metadataTable]="metadataTableDetalleAgrupacion"
      [key]="'key'" [filterGlobal]="true">
      <ng-template #addHeaderStart>
        <th class="header" *ngIf="modovisualizar">
          <div class="items-header">
            <span>Acción</span>
          </div>
        </th>
      </ng-template>
      <ng-template #addBodyStart let-row="row">
        <td class="a-datatable-datos-body-accion row-space" *ngIf="modovisualizar">
          <!-- <p-checkbox [inputId]="row.key" name="group2" [value]="row.key"
            (onChange)="addTarifa($event,row, 'D',null)" [disabled]="edicion"/> -->
          <p-button (onClick)="eliminarServicio(row,'A')" icon="pi pi-trash" pTooltip="Eliminar"></p-button>
        </td>
      </ng-template>
    </app-datatable>
  </div>
</p-dialog>
<!-- <p-dialog header="Orden de Compra" [(visible)]="visibleOCompra" [style]="{width: '90vw',height: '90vh'}"
  appendTo="body">

</p-dialog> -->
<p-dialog header="Autorización" [(visible)]="visibleAuth" [style]="{width: '30vw',height: '45vh'}" appendTo="body"
  closeOnEscape="false">
  <div class="a-w1">
    <form [formGroup]="groupAuth">
      <div class="a-w1-row card flex justify-center">
        <div class="flex flex-wrap gap-4">
          <div class="flex items-center gap-2">
            <div *ngFor="let tipo of tipoAuth" class="field-checkbox">
              <p-radiobutton [value]="tipo.key" formControlName="tipoauth" [inputId]="tipo.key"
                (ngModelChange)="mostrarModAuth($event)" />
              <label [for]="tipo.key" class="ml-2">{{ tipo.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="a-w1-row" style="padding-top: 20px;" *ngIf="!modoT">
        <div class="a-w1">
          <p-floatlabel class="w-full md:w-56" variant="on">
            <input inputId="on_label" pInputText formControlName="usuario" class="w-full md:w-56"
              [ngClass]="{'ng-invalid ng-dirty': this.groupAuth.get('usuario')?.invalid && (this.groupAuth.get('usuario')?.touched)}" />
            <label for="on_label">Usuario</label>
          </p-floatlabel>
          <small *ngIf="this.groupAuth.get('usuario')?.invalid && (this.groupAuth.get('usuario')?.touched)"
            class="text-red-600 text-xs">
            Este campo es obligatorio
          </small>
        </div>
      </div>
      <div class="a-w1-row" style="padding-top: 20px;" *ngIf="!modoT">
        <div class="a-w1">
          <p-floatlabel class="w-full md:w-56" variant="on">
            <p-password formControlName="contrasenia" inputStyleClass="w-full" styleClass="w-full md:w-56"
              class="w-full md:w-56" [feedback]="false" inputId="on_label"
              [ngClass]="{'ng-invalid ng-dirty': this.groupAuth.get('contrasenia')?.invalid && (this.groupAuth.get('contrasenia')?.touched)}"
              [toggleMask]="true" />
            <label for="on_label">Contraseña</label>
          </p-floatlabel>
          <small *ngIf="this.groupAuth.get('contrasenia')?.invalid && (this.groupAuth.get('contrasenia')?.touched)"
            class="text-red-600 text-xs">
            Este campo es obligatorio
          </small>
        </div>
      </div>
      <div class="a-w1-row" style="padding-top: 20px;" *ngIf="modoT">
        <div class="a-w1">
          <div style="display: flex; justify-content: center; align-items: center; gap: 10px;">
            <p-floatlabel class="w-11 md:w-56" variant="on">
              <input inputId="on_label" pInputText formControlName="token" class="w-11 md:w-56" [disabled]="btnToken"
                [maxlength]="6"
                [ngClass]="{'ng-invalid ng-dirty': this.groupAuth.get('token')?.invalid && (this.groupAuth.get('token')?.touched)}" />
              <label for="on_label">Token</label>
            </p-floatlabel>
            <p-button icon="pi pi-key" label="Generar Token" *ngIf="btnToken" (onClick)="GenerarTokenAuth()" />
            <small *ngIf="!btnToken" class="text-xs display: flex; flex-wrap: wrap; w-9; white-space: normal;">
              {{mensajeIntento}}
            </small>
          </div>
          <small *ngIf="this.groupAuth.get('token')?.invalid && (this.groupAuth.get('token')?.touched)"
            class="text-red-600 text-xs display: flex; flex-wrap: wrap; w-9; white-space: normal;">
            {{mensajeError}}
          </small>
        </div>
      </div>
    </form>
  </div>
  <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
    <p-button label="Autorizar" (onClick)="AutorizarCambioVenta('A')"></p-button>
    <p-button label="No Autorizar" (onClick)="AutorizarCambioVenta('N')"></p-button>
  </div>
</p-dialog>

<p-dialog header="Zonas" [(visible)]="visibleZonas" appendTo="body">
  <div class="a-example-full-width-alterno-content-row">

    <app-readonly-data-table [dataTable]="dtZonas" [metadataTable]="mtZonas" [key]="'ezon_codigo'"
      nombreListaHijos='detail' [style]="estilos" [filterGlobal]="true" [caption]="true"></app-readonly-data-table>

  </div>
</p-dialog>